// state
export const state = {
  regions: []
}

// getters
export const getters = {
  regions: state => {
    return state.regions
  }
}

// mutations
export const mutations = {
  SET_REGIONS(state, regions) {
    state.regions = regions
  },
}

// actions
export const actions = {
  setRegions({ commit }, regions) {
    commit('SET_REGIONS', regions)    
  }
}
